export default __webpack_public_path__ + "static/media/twitch.4378fa92.png";